import ICON_BUTTON_ARROW_WHITE from '../../../public/static/v4/event/icon-button-arrow-white.svg';
import ICON_BUTTON_ARROW from '../../../public/static/v4/event/icon-button-arrow.svg';

interface IProps {
  isWhiteIcon?: boolean;
}

export default function EventArrowIconV4({isWhiteIcon}: IProps) {
  return (
    <img
      src={isWhiteIcon ? ICON_BUTTON_ARROW_WHITE : ICON_BUTTON_ARROW}
      className="w-24 h-24"
      alt=""
    />
  );
}
